import {
  newSmartListConverter as _newSmartListConverter,
  smartListConverter as _smartListConverter,
} from '@griply/services';
import { SmartList } from '@griply/types';
import { FirestoreDataConverter } from 'firebase/firestore';

export const smartListConverter =
  _smartListConverter as unknown as FirestoreDataConverter<SmartList>;

export const newSmartListConverter = _newSmartListConverter;
